import { CarTaxiFront, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { DataTable } from "../components/DataTable";
import { Badge, Button, Card, EmptyState, Skeleton } from "../components/ui";
import { useVehicleRentals } from "../data/assets-platform-data";

export function VehicleRentalsPage() {
  const query = useVehicleRentals();
  if (query.isLoading) return <Skeleton className="dashboard-skeleton" />;
  if (query.error) {
    return (
      <EmptyState title="Não foi possível carregar as locações" description={query.error.message} />
    );
  }

  return (
    <Card
      title="Locação de veículos"
      description="Operação para motoristas de aplicativo, quilometragem, multas e manutenção."
      action={
        <Link to="/operacoes/nova?tipo=vehicle-rental">
          <Button>
            <Plus size={16} /> Nova locação
          </Button>
        </Link>
      }
    >
      <DataTable
        rows={query.data ?? []}
        getKey={(row) => row.id}
        columns={[
          {
            key: "number",
            header: "Contrato",
            render: (row) => (
              <span className="strong-link">
                <CarTaxiFront size={15} /> {row.number}
              </span>
            ),
          },
          { key: "driver", header: "Motorista", render: (row) => row.driver },
          { key: "vehicle", header: "Veículo", render: (row) => row.vehicle },
          {
            key: "frequency",
            header: "Cobrança",
            render: (row) => (
              <Badge tone="info">{row.frequency === "WEEKLY" ? "SEMANAL" : row.frequency}</Badge>
            ),
          },
          { key: "rent", header: "Valor", render: (row) => row.rent },
          { key: "due", header: "Vencimento", render: (row) => row.dueDay },
          { key: "mileage", header: "Quilometragem", render: (row) => row.mileage },
          {
            key: "status",
            header: "Status",
            render: (row) => (
              <Badge tone={row.status === "ACTIVE" ? "success" : "danger"}>{row.status}</Badge>
            ),
          },
        ]}
      />
    </Card>
  );
}
